import { Box, Stack, Typography, alpha, styled } from "@mui/material";
import { fadedPrimaryBg } from "features/onboarding/woocommerce/WooCommerceOnboardingPlatformLogoBox";
import { ReactNode } from "react";

const PanelIcon = styled(Box)(({ theme }) => ({
  width: 34,
  height: 34,
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.primary.main,
  flexShrink: 0,
  background: fadedPrimaryBg(theme),
}));

const StatChip = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  padding: "4px 10px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
  whiteSpace: "nowrap",
  maxWidth: 160,
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export interface AnalyticsCardPanelHeaderProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  statLabel?: string;
  action?: ReactNode;
}

function AnalyticsCardPanelHeader({
  icon,
  title,
  subtitle,
  statLabel,
  action,
}: AnalyticsCardPanelHeaderProps) {
  return (
    <Stack width="100%" sx={{ mb: subtitle ? 2 : 0 }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={1}
        width="100%"
      >
        <Stack
          direction="row"
          alignItems={subtitle ? "flex-start" : "center"}
          spacing={1.25}
          minWidth={0}
        >
          {icon ? <PanelIcon>{icon}</PanelIcon> : null}
          <Stack minWidth={0}>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ lineHeight: 1.2 }}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.5, lineHeight: 1.4 }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1} flexShrink={0}>
          {statLabel ? (
            <StatChip title={statLabel}>{statLabel}</StatChip>
          ) : null}
          {action}
        </Stack>
      </Stack>
    </Stack>
  );
}

export default AnalyticsCardPanelHeader;
